<template>
	<div v-show="bodyIsShow">
		<section id="formwrapSection" class="formwrapSection clearfix bac">
		<div class="formwrap">
			<form id="signUpfrom" class="signUpfrom" action="/hmtcj/applyForTcj" method="post">
				<!--<input type="hidden" id="groupbyNum" name="groupbyNum" :value="periodsInfo.id" />
				<input type="hidden" id="position" name="position" value="1" />
				<input type="hidden" id="groupbyType" name="groupbyType" value="1" />-->
				<p class="titleFont">第二步填写地址</p>
                <div class="sinform">
                    <em class="signUpfrom-icon signUpfrom-icon01"></em>
                    <input type="text" class="sinform-text" name="address" placeholder="请输入门票快递收件地址"  id="address" maxlength="200" >
                </div>
                <div class="sub-wrap">
                    <div class="singsubmit tobtn" @click="submit()" data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                        	完成领票
                    </div>
                </div>
				<div style="margin-bottom:1em;color:#999;text-align: center;margin-top: 0.46rem;" class="addxyroom">温馨提示：稍后会有客服人员跟您确认门票事宜，请注意接听</div>
			</form>
		</div>
		</section>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	 body {
        background-color: #1b1880;
    }
	.titleFont{
		.px2px(font-size, 36px);
		text-align:center;
		color:#fff;
		margin-top:0.93rem;
		margin-bottom:1.06rem;
	}
	.formwrap{
		width: 10.0rem;
		height: 100%;
	    margin: 0 auto;
	    padding-bottom: 1.5rem;
		background: #1b1880;
	}
</style>
<script>
import { Toast } from 'mint-ui';
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:false,
			periods:{
				cityId:10,
				successBannerList:[],
				// 已换成真实数据
				improveInfoTextFlag:1,
				// 已换成真实数据
				improveInfoText:"",
				// 已换成真实数据
				improveInfoPicFlag:1,
				// 已换成真实数据
				improveInfoPic:"",
				successBannerCb:false,
				picUrl:""
			},
			abTestFlag:null,
			// 已换成真实数据
			isTicket:null,
			address:null,
			// 已换成真实数据;
			car:null,
			buyway:1,
			buyList:[],
			// 已换成真实数据
			instalments:1,
			activityType:'9'            //场次类型
			
		}
	},
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/carExpo/carExpoperfect.css?v=123"
		});
		document.title="报名成功";
		// var applyId = "${applyId}";
	 //    var periodsId = '${periodsId}';
	 //    var sk = '${sk}';
	 //    var leaseCity = '${leaseCity}';
	 //    var lastInstalments = '${lastInstalments}';
	    window.cityId = self.$route.query.cityId;
	    self.periods.cityId =  self.$route.query.cityId;
		getCommonJsIns.initDefaultJS(self.webReady);
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');

	},
	methods:{
		webReady:function(){
			 // 备份this
			 var self = this;
			 if(self.$route.query.activityType==undefined){
				//
			}else{
				self.activityType=self.$route.query.activityType;
			}
			 this.bodyIsShow = true;
			 var str = (window.location.href).substr((window.location.href).indexOf("?"));
			 self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applySupplement + str,
				type:"get",
				data:{},
				success:function(data){
					getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/carfestival/perfectmsg.js",function(){});
					//数据保存
					 var result = data.response.result.periods;
					 var overall = data.response.result;
					
					// 判断数据请求状态
					 if (data.responseHeader.status==200) {
					 	self.periods.successBannerCb = result.successBannerCb;
					 	for(var i in result.successBannerList){
					 		self.periods.successBannerList.push(result.successBannerList[i]);
					 	}
				        self.periods.improveInfoTextFlag = result.improveInfoTextFlag;
				        self.periods.improveInfoText = result.improveInfoText;
				        self.periods.improveInfoPicFlag = result.improveInfoPicFlag;
			            self.periods.improveInfoPic = result.improveInfoPic;
			            self.periods.picUrl =  result.picUrl;
			            if(overall.abTestFlag){
			            	self.abTestFlag = overall.abTestFlag;
			            	console.log(self.abTestFlag);
			            }

			            if(overall.address){
			            	self.address = overall.address;
			            	console.log(self.address);
			            }

			            if(overall.car){
			            	self.car = overall.car;
			            	console.log(self.car);
			            }

			            self.isTicket = overall.isTicket;

			            self.instalments = overall.instalments;
					 }
				},
				error:function(){}
			});
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.buyWays,
				type:"get",
				data:{
					cityId : self.$route.query.cityId
				},
				success:function(data){
					// 判断数据请求状态
					 if (data.responseHeader.status==200) {
					 	self.buyList = data.response.result;
					 }
				},
				error:function(){}
			});
		},
		submit:function(){
			var self = this;
			$("#submitBtn").attr("disabled","disabled");
//			var relF = $("#side-carstyle").data("dada");
//			if((!relF || relF == "") && $("#insertCar").size() > 0) {
//				Toast({
//                message: "请选择品牌或车型",
//                position: 'middle',
//                duration: 2000
//              });
//			}
			if($("#address").val() =="") {
				Toast({
                  message: "请输入门票地址",
                  position: 'middle',
                  duration: 2000
                });
			} else {
//				var rel;
//				if(typeof(relF) != "undefined") {
//					rel = relF.split("@#");
//				}
				var sinData = {};
				if(self.$route.query.sk){
					sinData["sk"] = self.$route.query.sk
				};
				sinData['applyId'] = this.$route.query.applyId;
				sinData['groupbyNum'] = this.$route.query.periodsId;
				sinData['buyType'] = $("#index-cartype").find('.active').attr("data-buytype");
				sinData['splitMoney'] = $("#index-bystages").find('.active').attr("data-splitmoney");
//				if(typeof(relF) != "undefined") {
//					sinData['brandId'] = rel[0];
//					sinData['carStyleId'] = rel[1];
					sinData['noCheckBrandStyle'] = 0;

//				} else {
//					sinData['noCheckBrandStyle'] = 1;
//				}
				var addressId = $("#address").val();
				if(addressId) {
					sinData['paperTicketAddress'] = $("#address").val();
				}
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.supplementForM,
					type:"post",
					data:sinData,
					success:function(data){
						$("#submitBtn").removeAttr("disabled");
						if(data.responseHeader.status == 200){
							window.location.href = "/mapply/carExpo/carExpoSuccess?applyId=" + self.$route.query.applyId+"&cityPy="+self.$route.query.cityPy +"&activityType="+self.activityType+ "&periodsId=" + self.$route.query.periodsId + "&t=" + Date.parse(new Date());
						}else{
							alert("请求失败")
						}
					},
					error:function(){
						$("#submitBtn").removeAttr("disabled");
						Toast({
		                  message: "系统忙，请稍后",
		                  position: 'middle',
		                  duration: 2000
		                });
					}
				});
			}
		}

		
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carExpo/carExpoperfect.vue